import React, { createContext, useContext, useState, useEffect } from 'react';

const UserRoleContext = createContext();

export const UserRoleProvider = ({ children }) => {
  const [userRoles, setUserRoles] = useState([]);

  useEffect(() => {
    // Get roles from sessionStorage when the app loads
    const staffInfo = sessionStorage.getItem('staff_info');
    if (staffInfo) {
      const { role } = JSON.parse(staffInfo);
      setUserRoles(role || []);
    }
  }, []);

  const hasRole = (role) => {
    return userRoles.includes(role);
  };

  const hasAnyRole = (roles) => {
    return roles.some(role => userRoles.includes(role));
  };

  const hasAllRoles = (roles) => {
    return roles.every(role => userRoles.includes(role));
  };

  return (
    <UserRoleContext.Provider value={{ userRoles, hasRole, hasAnyRole, hasAllRoles }}>
      {children}
    </UserRoleContext.Provider>
  );
};

export const useUserRole = () => useContext(UserRoleContext); 